import { render } from "./index.vue?vue&type=template&id=59584477"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=59584477&lang=css"

import exportComponent from "/Users/zqj/Documents/git/H5/Website/WaterHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__